import { Directive, DOCUMENT, ElementRef, HostListener, inject, input } from '@angular/core';

@Directive({
  selector: '[addClassOnView]',
  standalone: true,
})
export class AddClassOnViewDirective {
  readonly offset = input(0);
  readonly addClass = input.required<string>();
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  readonly #window = inject(DOCUMENT).defaultView as Window;

  @HostListener('window:scroll') onScrollEvent() {
    const element = this.elementRef.nativeElement;
    const scroll = this.#window.scrollY + this.#window.innerHeight;
    const top = element.offsetTop;
    if (scroll - this.offset() >= top) {
      element.classList.add(this.addClass());
    }
  }
}
